module.exports = __webpack_public_path__ + "static/media/img_2_1.ef9298f4.png";